import VFooter from './VFooter';
export { VFooter };
export default VFooter;
//# sourceMappingURL=index.js.map